import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { ReadMoreButton } from "@root/shared/components/ReadMoreButton";
import { colors } from "@root/shared/styles/sprinkles.css";
import { MultiLineText } from "@root/shared/components/MultiLineText";

import * as styles from "./styles.css";

type Item = {
  subtitle?: string;
  content: string;
};

type Props = {
  title: string;
  attention?: string;
  contents: Item[];
};

export const ExpandableGuidanceBox: FC<Props> = ({ title, attention, contents }) => {
  return (
    <ReadMoreButton size="large">
      <GuidanceBox themeColor="pink">
        <p className={styles.title}>
          <Icon name="attention" fontSize="16px" color={colors.Biyo} />
          {title}
        </p>
        {attention && (
          <p className={styles.attention}>
            {/* TODO: sprinklesにimportantなしのDangerカラーが追加され次第、ベタがきをやめる */}
            <Icon name="view" fontSize="16px" color="#CC2D2D" />
            {attention}
          </p>
        )}
        {contents.map((content) => (
          <div key={content.content}>
            {content.subtitle && <p className={styles.subtitle}>{content.subtitle}</p>}
            <MultiLineText text={content.content} />
          </div>
        ))}
      </GuidanceBox>
    </ReadMoreButton>
  );
};
